import SourceBadges from './SourceBadges.svelte';

export default {
  component: SourceBadges,
  name: 'Source Badges'
}